// Component to show a Dispatch Schedule Form inside a modal
import { DispatchScheduleDoc } from '@isd/lib/firebase/db/metaTypes';

import DispatchScheduleForm from '@/components/DispatchSchedule/DispatchScheduleForm';
import Modal from '@/components/Modal/Modal';

export type CloseDispatchScheduleFormModalFn = (
  ds: DispatchScheduleDoc | void
) => void;

export default function DispatchScheduleFormModal({
  isOpen,
  onClose,
  dispatchScheduleDoc,
}: {
  isOpen: boolean;
  onClose: CloseDispatchScheduleFormModalFn;
  dispatchScheduleDoc: DispatchScheduleDoc | null;
}) {
  return (
    <Modal isOpen={isOpen}>
      {isOpen && (
        <DispatchScheduleForm
          onClose={onClose}
          dispatchScheduleDoc={dispatchScheduleDoc}
        />
      )}
    </Modal>
  );
}
